/**
 * auth: Tank
 * date: 2017-8-31
 * desc: 注册过滤器
 */

import Vue from 'vue';

// 定义过滤器
Vue.filter('statusFilter', function(value) {
    var result = '';
    switch(+value) {
        case 0:{
            result = '自由人';
            break;
        }
        case 1:{
            result = '跟进中';
            break;
        }
        case 2:{
            result = '已登录';
            break;
        }
    }
    return result;
});

Vue.filter('joinServicearea', function(value) {
    var result = '';
    if(value && value.length) {
        result = value.join('、');
    }else {
        result = value;
    }
    return result;
});

// 多于5个字显示省略号
Vue.filter('nameEllipsis', function(value) {
    value += '';
    var result = '';
    if(value.length > 5) {
        result = value.substring(0,5) + '...';
    }else {
        result = value;
    }
    return result;
});

// 记录状态
Vue.filter('reportstatus', function(value) {
    value += '';
    var result = '';
    switch(value) {
        default:
        case '0': {
            result = '全部';
            break;
        }
        case '1': {
            result = '有报备';
            break;
        }
        case '2': {
            result = '有到访';
            break;
        }
        case '3': {
            result = '有成交';
        }
    }
    return result;
});

Vue.filter('delDecimals', function (Num){
    var newNum;
    newNum = "";
    Num += '';
    if(Num){
        newNum = Num%1 == 0 ? Math.floor(Num) : (Num*1).toFixed(2);
        return newNum;
    }else{
        return '0';
    };
});
Vue.filter('savedecimal', function (num){
    let decimalNum = "", newNum = 0;
    newNum = num*1;
    if(newNum){
        decimalNum = newNum % 1 == 0 ?  newNum.toFixed(2) : (Math.floor(newNum*100)/100).toFixed(2);
        return decimalNum;
    }else{
        return '0.00';
    }
});



// WEBPACK FOOTER //
// ./src/mytools/filters.js